angular.module('aprima-provider-api').factory('ExternalPatientsRepository', ['AprimaRestangular', 'MetadataRepository', 'AprimaAnalytics', 'storage', '_',
    function (AprimaRestangular, MetadataRepository, AprimaAnalytics, storage, _) {
        'use strict';

        var storageKey = 'external-patients.reload-list';

        function isExternalPatientsModifiedSinceLastAccess () {
            return storage.get(storageKey) || false;
        }

        function requestExternalPatients(result) {
            storage.set(storageKey, true);
            return result;
        }

        function getExternalPatients(externalPatientListId, restangularOptions, appComponent) {
            restangularOptions = _.defaults(restangularOptions || {}, {ignoreCache: isExternalPatientsModifiedSinceLastAccess()});

            var timing = AprimaAnalytics.startTiming(appComponent || 'PatientRepository', 'api', 'getExternalPatients');
            var restangular = AprimaRestangular.get(restangularOptions);
            return restangular.all('externalpatients/' + externalPatientListId).getList({
                date: moment().startOf('day').toJSON()
            }).finally(function() {
                timing.stop();

                if(restangularOptions.ignoreCache) {
                    storage.remove(storageKey);
                }
            });
        }

        function getExternalPatient(hospitalRoundId) {
            return AprimaRestangular.get().all('externalpatients').one('patients').one(hospitalRoundId).get();
        }

        function addExternalPatient(command) {
            return AprimaRestangular.get().all('externalpatients').post(command).then(requestExternalPatients);
        }

        function editExternalPatient(command) {
            return AprimaRestangular.get().all('externalpatients').one('patients').one(command.HospitalRoundId).customPUT(command).then(requestExternalPatients);
        }

        function getAddExternalPatientModelMetadata($scope) {
            return MetadataRepository.getMetadata('addexternalpatient', $scope);
        }

        function getEditExternalPatientModelMetadata($scope) {
            return MetadataRepository.getMetadata('editexternalpatient', $scope);
        }

        function dischargePatient(hospitalRoundId) {
            return AprimaRestangular.get()
                .all('externalpatients')
                .one(hospitalRoundId)
                .post('', {
                    HospitalRoundId: hospitalRoundId
                })
                .then(requestExternalPatients);
        }

        return {
            getExternalPatients: getExternalPatients,
            getExternalPatient: getExternalPatient,
            addExternalPatient: addExternalPatient,
            editExternalPatient: editExternalPatient,
            getAddExternalPatientModelMetadata: getAddExternalPatientModelMetadata,
            getEditExternalPatientModelMetadata: getEditExternalPatientModelMetadata,
            dischargePatient: dischargePatient
        };
    }]);